import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { UserDataService } from 'src/app/services/user-data.service';
import * as ExcelJS from 'exceljs';

@Component({
  selector: 'app-configuracion-alarmas',
  templateUrl: './configuracion-alarmas.component.html',
  styleUrls: ['./configuracion-alarmas.component.css']
})
export class ConfiguracionAlarmasComponent {

  //DATOS TANQUES
  devicesList: any [] = [];
  tankList: any = [];
  tabla: any = [];

  //TABLA
  dataSource :any;
  displayedColumns: string[] = ['numeroTanque', 'deviceLabel','establishmentName','nivelAlarm', 'temperaturaAltaAlarm', 'temperaturaBajaAlarm','presionAltaAlarm', 'presionBajaAlarm'];
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  //ERROR
  errorMessage : string ="";

  //CARGA
  datosRecibidos: boolean = false;

  //USER
  userData: any = [];

  //Subscripciones
  private alarmasSubscription: Subscription | undefined;

  constructor(private deviceService: DeviceService, private error429: Error429Service,
    private userDataService: UserDataService){
    this.userData = this.userDataService.getUserData();
  }

  ngOnInit(): void {
    this.alarmasSubscription = this.deviceService.getDevicesDataNew().subscribe({
      next:resp =>{
        this.devicesList = resp;
        for(let i=0; i<this.devicesList.length; i++){
          for(let j=0; j<this.devicesList[i].tanks.length; j++){
            this.tankList.push({
              tanque: this.devicesList[i].tanks[j],
              device: this.devicesList[i],
            });
          }
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () =>{
        this.tankList = this.devolverTanquesConAlarmas();
        // console.log(this.tankList);
        for(let i=0; i<this.tankList.length; i++){
          const jsonAlarms = JSON.parse(this.tankList[i].tanque.alarm_ranges);
          this.tabla.push({
            numeroTanque: this.tankList[i].tanque.custom_num,
            tanqueID: this.tankList[i].tanque.id,
            deviceLabel: this.tankList[i].device.dev_label,
            deviceReference: this.tankList[i].device.dev_reference,
            deviceID: this.tankList[i].device.id,
            establishmentName: this.tankList[i].device.establishment.est_name,
            establishmentID: this.tankList[i].device.establishment.id,
            nivelAlarm: this.soloDosDecimalesConComa(jsonAlarms.beerLevelMin),
            presionAltaAlarm: this.soloDosDecimalesConComa(jsonAlarms.beerPressureMax),
            presionBajaAlarm: this.soloDosDecimalesConComa(jsonAlarms.beerPressureMin),
            temperaturaAltaAlarm: this.soloDosDecimalesConComa(jsonAlarms.beerTemperatureMax),
            temperaturaBajaAlarm: this.soloDosDecimalesConComa(jsonAlarms.beerTemperatureMin),
          })
        }
        // console.log("Tabla",this.tabla);
        this.dataSource = new MatTableDataSource(this.tabla);
        //Filtrado personalizado
        this.dataSource.filterPredicate = (data: any, filter: string) => {
          const dataStr = this.displayedColumns
            .filter(key => key !== 'deviceID' && key !== 'establishmentID')
            .map(key => data[key])
            .join('')
            .toLowerCase();
      
          return dataStr.includes(filter);
        };
        setTimeout(() => {
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }, 0);
        this.datosRecibidos = true;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.alarmasSubscription) {
      this.alarmasSubscription.unsubscribe();
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  devolverTanquesConAlarmas(){
    const tanquesConAlarmas = this.tankList.filter((tanque: any) => {
      const alarmRanges = JSON.parse(tanque.tanque.alarm_ranges);
      // Verifica si al menos uno de los campos de alarmRanges no es null
      return Object.values(alarmRanges).some(value => value !== null);
    });
    return tanquesConAlarmas;
  }

  soloDosDecimalesConComa(numero: number){
    if(Number.isNaN(numero)){
      return null;
    } else {
      if(numero == undefined){
        return null;
      } else {
        return numero.toLocaleString(this.userData.region, { maximumSignificantDigits: 3 });
      }
    }
  }

  descargarExcel() {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Tabla');
  
    // Agregar encabezados de columna
    worksheet.addRow([
      'Número de Tanque',
      'ID de Tanque',
      'Etiqueta del Dispositivo',
      'Referencia del Dispositivo',
      'ID del Dispositivo',
      'Nombre del Establecimiento',
      'ID del Establecimiento',
      'Nivel de Alarma',
      'Presión Alta de Alarma',
      'Presión Baja de Alarma',
      'Temperatura Alta de Alarma',
      'Temperatura Baja de Alarma'
    ]);
  
    // Agregar datos de la tabla
    this.tabla.forEach((row: any) => {
      worksheet.addRow([
        row.numeroTanque,
        row.tanqueID,
        row.deviceLabel,
        row.deviceReference,
        row.deviceID,
        row.establishmentName,
        row.establishmentID,
        row.nivelAlarm,
        row.presionAltaAlarm,
        row.presionBajaAlarm,
        row.temperaturaAltaAlarm,
        row.temperaturaBajaAlarm
      ]);
    });
  
    // Escribir el archivo Excel
    workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
  
      // Descargar el archivo
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Configuración de Alarmas de Tanques DataBeer.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  }

}
